import styled from 'styled-components'
import { theme } from '@provi/provi-components'

export const SectionContainer = styled.div`
  margin-bottom: 32px;

  ${theme.breakpoints.down('md')} {
    margin-bottom: 24px;
  }
`

export const SectionTitle = styled.h3`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #999999;
  margin: 0 0 12px 0;

  ${theme.breakpoints.down('md')} {
    margin: 0 0 16px 0;
  }
`

export const Description = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #666666;
  margin: 0 0 16px 0;

  ${theme.breakpoints.down('md')} {
    font-size: 16px;
    line-height: 24px;
  }
`

export const Select = styled.select`
  width: 100%;
  max-width: 500px;
  padding: 8px 12px;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #262626;
  background: white;
  border: 1px solid #cccccc;
  border-radius: 6px;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%236B7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3E%3C/svg%3E");
  background-position: right 12px center;
  background-repeat: no-repeat;
  background-size: 20px;
  height: 40px;

  &:focus {
    outline: none;
    border-color: #0273ff;
    box-shadow: 0 0 0 3px rgba(2, 115, 255, 0.1);
  }

  ${theme.breakpoints.down('md')} {
    width: 100%;
    font-size: 16px;
    line-height: 24px;
  }
`
